import React from "react";

export interface IFieldProps {
    label?: string;
    name?: string;
    helperText?: React.ReactNode;
    error?: React.ReactNode;
    labelTrailing?: React.ReactNode;
    tooltip?: string;
}
